<template>
    <hr />

    <div class="footer-row" :class="{ 'single-button': !showChooseGuardian }">
        <button
            v-if="showChooseGuardian"
            class="btn btn-white"
            type="button"
            @click="$emit('choose-guardian')"
        >
            {{ chooseGuardianText }}
        </button>
        <button
            class="btn btn-light"
            type="button"
            @click="$emit('open-history')"
        >
            {{ historyText }}
        </button>
    </div>
</template>

<script>
export default {
    name: 'PanelFooter',
    props: {
        showChooseGuardian: {
            type: Boolean,
            default: false,
        },
        chooseGuardianText: {
            type: String,
            default: '',
        },
        historyText: {
            type: String,
            default: '',
        },
    },
    emits: ['choose-guardian', 'open-history'],
};
</script>

<style scoped>
hr {
    margin-bottom: var(--space-3);
}

.footer-row {
    display: flex;
    justify-content: space-between;
    gap: var(--space-3);
}

.footer-row.single-button {
    justify-content: flex-start !important;
}

.footer-row.single-button .btn {
    margin-left: 0;
    margin-right: auto;
}
</style>
